// extracted by mini-css-extract-plugin
module.exports = {"action":"index-module--action--2qpxT Box-module--box--X0EGm"};